<script setup>
import { frontendURL } from 'dashboard/helper/URLHelper.js';
import { useAccount } from 'dashboard/composables/useAccount';
import OnboardingFeatureCard from './OnboardingFeatureCard.vue';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStoreGetters } from 'dashboard/composables/store';

const getters = useStoreGetters();
const { t } = useI18n();
const { accountId } = useAccount();
const globalConfig = computed(() => getters['globalConfig/get'].value);
const currentUser = computed(() => getters.getCurrentUser.value);
let aiAdminBackgroundUrl = window?.chatwootConfig?.viteAppAIAdminBackgroundUrl;

const greetingMessage = computed(() => {
  const hours = new Date().getHours();
  let translationKey;
  if (hours < 12) {
    translationKey = 'ONBOARDING.GREETING_MORNING';
  } else if (hours < 18) {
    translationKey = 'ONBOARDING.GREETING_AFTERNOON';
  } else {
    translationKey = 'ONBOARDING.GREETING_EVENING';
  }
  return t(translationKey, {
    name: currentUser.value.name,
    installationName: globalConfig.value.installationName,
  });
});

// 定义 handleAdminRedirect 方法
const handleAdminRedirect = () => {
  console.info("handleAdminRedirect aiAdminBackgroundUrl: ", window?.chatwootConfig?.viteAppAIAdminBackgroundUrl)
  window.open(aiAdminBackgroundUrl, '_blank');
};
</script>

<template>
  <div class="min-h-screen lg:max-w-5xl max-w-4xl mx-auto auto-rows-min gap-4 p-8 w-full font-inter overflow-auto">
    <div class="col-span-full self-start">
      <p class="text-xl font-semibold text-slate-900 dark:text-white font-interDisplay tracking-[0.3px]">
        {{ greetingMessage }}
      </p>
      <p class="text-slate-600 dark:text-slate-400 max-w-2xl text-base">
        {{
          $t('ONBOARDING.DESCRIPTION', {
            installationName: globalConfig.installationName,
          })
        }}
      </p>
    </div>

    <div class="col-span-full self-start mt-16">
      <p class="text-xl font-semibold text-slate-900 dark:text-white font-interDisplay tracking-[0.3px]">
        {{$t('ONBOARDING.ACCESS_MODE_TITLE')}} →
      </p>
      <p class="text-slate-600 dark:text-slate-400 max-w-2xl text-base">
        {{$t('ONBOARDING.ACCESS_MODE_DESC')}}
      </p>
      <router-link :to="frontendURL(`accounts/${accountId}/settings/inboxes/new`)">
        <woot-button class="clear link">
          {{$t('ONBOARDING.ACCESS_MODE_TITLE')}} →
        </woot-button>
      </router-link>
    </div>

    <div class="col-span-full self-start mt-16">
      <p class="text-xl font-semibold text-slate-900 dark:text-white font-interDisplay tracking-[0.3px]">
        {{$t('ONBOARDING.PAY_MODE_TITLE')}}
      </p>
      <p class="text-slate-600 dark:text-slate-400 max-w-2xl text-base">
        {{$t('ONBOARDING.PAY_MODE_DESC')}}
      </p>
      <router-link :to="frontendURL(`accounts/${accountId}/billing/configure`)">
        <woot-button class="clear link">
          {{$t('ONBOARDING.PAY_MODE_TITLE')}} →
        </woot-button>
      </router-link>
    </div>

    <!-- <div class="col-span-full self-start mt-16">
      <p class="text-xl font-semibold text-slate-900 dark:text-white font-interDisplay tracking-[0.3px]">
        AI管理系统
      </p>
      <p class="text-slate-600 dark:text-slate-400 max-w-2xl text-base">
        针对每一个用户进行细致化管理的AI管理用户问答
      </p>
      <a>
        <woot-button class="clear link" @click="handleAdminRedirect">
          {{ $t(`SIDEBAR.ADMIN`) }} →
        </woot-button>
      </a>
    </div> -->
    <!-- <OnboardingFeatureCard
      image-src="/dashboard/images/onboarding/omnichannel-inbox.png"
      image-alt="Omnichannel"
      to="settings_inbox_new"
      :title="$t('ONBOARDING.ALL_CONVERSATION.TITLE')"
      :description="$t('ONBOARDING.ALL_CONVERSATION.DESCRIPTION')"
      :link-text="$t('ONBOARDING.ALL_CONVERSATION.NEW_LINK')"
    />
    <OnboardingFeatureCard
      image-src="/dashboard/images/onboarding/teams.png"
      image-alt="Teams"
      to="settings_teams_new"
      :title="$t('ONBOARDING.TEAM_MEMBERS.TITLE')"
      :description="$t('ONBOARDING.TEAM_MEMBERS.DESCRIPTION')"
      :link-text="$t('ONBOARDING.TEAM_MEMBERS.NEW_LINK')"
    />
    <OnboardingFeatureCard
      image-src="/dashboard/images/onboarding/canned-responses.png"
      image-alt="Canned responses"
      to="canned_list"
      :title="$t('ONBOARDING.CANNED_RESPONSES.TITLE')"
      :description="$t('ONBOARDING.CANNED_RESPONSES.DESCRIPTION')"
      :link-text="$t('ONBOARDING.CANNED_RESPONSES.NEW_LINK')"
    />
    <OnboardingFeatureCard
      image-src="/dashboard/images/onboarding/labels.png"
      image-alt="Labels"
      to="labels_list"
      :title="$t('ONBOARDING.LABELS.TITLE')"
      :description="$t('ONBOARDING.LABELS.DESCRIPTION')"
      :link-text="$t('ONBOARDING.LABELS.NEW_LINK')"
    /> -->
  </div>
</template>
